<form [formGroup]="form">
  <ui-input-password [form]="form" [field]="passwordFields.password" *ngIf="passwordFields?.password"
    (change)="checkPasswordValidation($event)"></ui-input-password>
  <ui-input-password [form]="form" [field]="passwordFields.passwordRepeat" *ngIf="passwordFields?.passwordRepeat">
  </ui-input-password>
  <ui-password-criteria></ui-password-criteria>
  <ui-error-box [error]="error"></ui-error-box>
</form>
